export default __webpack_public_path__ + "static/media/About Img.899075e1.png";